import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { hookFormZod } from '@ipfabric/ui-components/utils/hookForm/hookFormZod';
import { sessionTimeouts } from '@ipfabric/utils';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export type DeviceAuthenticationFieldValues = { deviceAuthentication: string };
export type DeviceAuthenticationOutputValues = { deviceAuthentication: number };

export const deviceAuthentication: FormSnippet<
  DiscoverySettingsObject,
  DeviceAuthenticationFieldValues,
  DeviceAuthenticationOutputValues
> = {
  render: ({ form }) => (
    <FormTextField
      control={form.control}
      type='number'
      name='deviceAuthentication'
      description='Time to wait for login prompt appear'
      label='Device authentication'
      endAdornment='seconds'
      inputWidthClassName='w-60'
    />
  ), // Placeholder for the actual component
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.deviceAuthentication =
      model.timeouts?.authentication?.toString() ?? '';
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.timeouts ??= {};
    modelDraft.timeouts.authentication = transformedValues.deviceAuthentication;
  },
  schema: z.object({
    deviceAuthentication: hookFormZod.numberInputWith(
      hookFormZod.minMax(sessionTimeouts.min, sessionTimeouts.max),
    ),
  }),
};
